import { jsx as _jsx } from "react/jsx-runtime";
import { injectIntl } from "react-intl";
import { WithSearch } from "@elastic/react-search-ui";
import { FilterOptionEnum } from "../../models/dataModel";
import { hasProductBeenSelected } from "../../utils/functions";
import { RadioButtonFacet } from "./RadioButtonFacet";
const FacetWrapper = injectIntl(({ intl, labelKey, options, showMore, onChange, onMoreClick, }) => {
    const allProductsStr = intl.formatMessage({ id: "facets.product.allProducts" });
    function getAllProductsCount() {
        return options.reduce((counter, option) => {
            if (option.count)
                counter += option.count;
            return counter;
        }, 0);
    }
    function getProductOptions(filters, facets) {
        const productOptions = options[0]?.value === allProductsStr
            ? options
            : [
                {
                    count: getAllProductsCount(),
                    value: allProductsStr,
                    selected: !hasProductBeenSelected(filters),
                },
                ...options,
            ];
        const selectedProductValue = filters
            .find((filter) => filter.field === FilterOptionEnum.PRODUCT)
            ?.values.find((value) => typeof value === "string");
        const allProductFacetOptions = facets?.[FilterOptionEnum.PRODUCT]?.flatMap((facet) => facet.data) || [];
        const selectedProduct = selectedProductValue
            ? productOptions.find((option) => option.value === selectedProductValue) ||
                allProductFacetOptions.find((option) => option.value === selectedProductValue) || {
                value: selectedProductValue,
                selected: true,
            }
            : productOptions.find((option) => option.value !== allProductsStr && option.selected);
        const optionsWithSelectedProduct = selectedProduct && !productOptions.some((option) => option.value === selectedProduct.value)
            ? [...productOptions, selectedProduct]
            : productOptions;
        return selectedProduct
            ? [
                { ...selectedProduct, selected: true },
                ...optionsWithSelectedProduct.filter((option) => option.value !== selectedProduct.value),
            ]
            : productOptions;
    }
    function selectProductOption(option, removeFilter) {
        option === allProductsStr ? removeFilter(FilterOptionEnum.PRODUCT) : onChange(option);
    }
    return (_jsx(WithSearch, { mapContextToProps: ({ filters, facets, removeFilter }) => ({ filters, facets, removeFilter }), children: ({ filters, facets, removeFilter, }) => (_jsx(RadioButtonFacet, { label: labelKey, options: getProductOptions(filters, facets), showMore: showMore, onChange: (option) => selectProductOption(option, removeFilter), onMoreClick: onMoreClick })) }));
});
/**
 * Renders the "Select product" facet.
 * If no product has been selected, sets the filter as "All products".
 * @param label name of the facet
 * @param options options for the facet
 * @param onChange handles selecting an option
 */
export const SelectProductFacet = ({ label, options, showMore, onChange, onMoreClick, }) => {
    return (_jsx(FacetWrapper, { labelKey: label, options: options, showMore: showMore, onChange: onChange, onMoreClick: onMoreClick }));
};
